import Axios from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react'
import itemTypeList from '../../common/itemTypeList';
import NotData from '../../components/NotData';
import { useNavigate } from 'react-router-dom';

const Chart_1 = () => {

  const navigate = useNavigate();

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  // 숫자 천자리 콤마
  function NumberConvert(num) {
    let num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }

  const firstCursor = useRef(null);
    
  const [books_tb, setBooks_tb] = useState([]);
  const [books_ds, setBooks_ds] = useState([]);
  const [books_jy, setBooks_jy] = useState([]);
  const [books_cd, setBooks_cd] = useState([]);

  const columns_tb = [ 'No', '브랜드', '제품 이름', '탄방' ];
  const columns_ds = [ 'No', '브랜드', '제품 이름', '둔산' ];
  const columns_jy = [ 'No', '브랜드', '제품 이름', '자양' ];
  const columns_cd = [ 'No', '브랜드', '제품 이름', '충대' ];
  
  const [itemType, setItemType] = useState('전체');
  const [searchText, setSearchText] = useState('');

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // 날짜 및 바로 실행될 부분
  useEffect(()=>{
    document.title = '기간별 조회';

    firstCursor.current.focus();

    setStartDate(toDay.minusDate(30))
    setEndDate(toDay.date)
  }, []);

  // 분류 탭 부분
  const handleSelect = async (e) => {
  setItemType(e.target.value);

  firstCursor.current.focus();
  };

  // 조회 버튼 클릭시
  const btnSearchClick = async (e)=>{
    e.preventDefault();

    if(itemType === '전체' && searchText === '') return alert('분류 및 검색어를 입력해주세요');
    
    if(searchText !== '' && itemType !== '전체'){
      itemTypeNameSearch(); // 분류와 제품명 동시 조회
    } else if(itemType !== '전체') {
      itemTypeSearch(); // 분류만 조회
    } else if (searchText !== '') {
      itemNameSearch(); // 제품명만 조회
    }
  }

  // 분류 검색
  const itemTypeSearch = async ()=>{

    await Axios.get(`/api/salechart/chart_type`, {
      params: { 
        type: itemType, startDate: startDate, endDate: endDate
      }
    })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks_tb(res.data[0])
        setBooks_ds(res.data[1])
        setBooks_jy(res.data[2])
        setBooks_cd(res.data[3])
      } else {
        setBooks_tb([]);
        setBooks_ds([]);
        setBooks_jy([]);
        setBooks_cd([]);
      }
    });
  }

  // 제품명 검색
  const itemNameSearch = async ()=>{
    await Axios.get(`/api/salechart/chart_name`, {
      params: { 
        startDate: startDate, endDate: endDate, searchText: searchText
      }
    })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks_tb(res.data[0])
        setBooks_ds(res.data[1])
        setBooks_jy(res.data[2])
        setBooks_cd(res.data[3])
      } else {
        setBooks_tb([]);
        setBooks_ds([]);
        setBooks_jy([]);
        setBooks_cd([]);
      }
    });
  }

  // 분류 + 제품명 검색
  const itemTypeNameSearch = async ()=>{
    await Axios.get('/api/salechart/chart_typename', {
      params: {
        startDate: startDate, endDate: endDate, searchText: searchText, type: itemType
      }
    })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks_tb(res.data[0])
        setBooks_ds(res.data[1])
        setBooks_jy(res.data[2])
        setBooks_cd(res.data[3])
      } else {
        setBooks_tb([]);
        setBooks_ds([]);
        setBooks_jy([]);
        setBooks_cd([]);
      }
    })
  }

  // 셀렉트 테스트
  const [selectedRowTB, setSelectedRowTB] = useState(-1);
  const [selectedRowDS, setSelectedRowDS] = useState(-1);
  const [selectedRowJY, setSelectedRowJY] = useState(-1);
  const [selectedRowCD, setSelectedRowCD] = useState(-1);

  return (
    
    <div className='p-3 flex flex-col gap-3 whitespace-nowrap'>
      <div className='flex justify-between items-center'>
        <ul className='flex gap-3'>
          <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto border-[1px] border-yellow-500 rounded-md`} onClick={(e)=>navigate('/salechart/chart_1')}>기간별 조회</li>
          <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto}`} onClick={(e)=>navigate('/salechart/chart_2')}>시간대 조회</li>
        </ul>
      </div>
      
      <div className='grid grid-cols-1 md:flex md:justify-between text-sm md:h-[calc(100vh-8.9rem)] gap-2'>
      
        {/* 메인 */}
        <div className='relative w-full md:w-3/4 grid md:grid-cols-2 gap-5 md:gap-2'>

          <div className='overflow-y-auto md:h-full h-[30vh] border-[1px] border-gray-500 rounded-sm'>
            <table id='tb_table' className='w-full h-10'>
              <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center border-b-[1px] border-gray-500 sticky top-0 z-10'>
                <tr className=''>
                  {columns_tb.map((column) => (
                    <th className='p-3' key={column}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody className='text-center'>
                {
                  books_tb.length
                  ?
                  books_tb.map((book, idx) => (
                    <tr className=
                    {`
                      duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                      ${selectedRowTB === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                    `}
                    key={idx} onClick={(e)=>{
                      // 셀렉트 테스트
                      setSelectedRowTB(idx);
                      window.sessionStorage.setItem('select_copy', book.name);
                    }}>
                      <td className='p-2.5'>{idx + 1}</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.brand}</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.name}</td>
                      <td className='p-2.5'>{NumberConvert(book.TOTAL_TB)} 개</td>
                    </tr>
                  ))
                  :
                  <tr className='relative'>
                    <td className='absolute w-full md:top-[10vh] top-[3vh] left-auto'>
                      <NotData/>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <div className='overflow-y-auto md:h-full h-[30vh] border-[1px] border-gray-500 rounded-sm'>
            <table id='ds_table' className='w-full'>
              <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center border-b-[1px] border-gray-500 sticky top-0 z-10'>
                <tr>
                  {columns_ds.map((column) => (
                    <th className='p-3' key={column}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody className='text-center'>
                {
                  books_ds.length ?
                  books_ds.map((book, idx) => (
                    <tr className=
                    {`
                      duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                      ${selectedRowDS === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                    `}
                    key={idx} onClick={(e)=>{
                      // 셀렉트 테스트
                      setSelectedRowDS(idx);
                      window.sessionStorage.setItem('select_copy', book.name);
                    }}>
                      <td className='p-2.5'>{idx + 1}</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.brand}</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.name}</td>
                      <td className='p-2.5'>{NumberConvert(book.TOTAL_DS)} 개</td>
                    </tr>
                  ))
                  :
                  <tr className='relative'>
                    <td className='absolute w-full md:top-[10vh] top-[3vh] left-auto'>
                      <NotData/>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <div className='overflow-y-auto md:h-full h-[30vh] border-[1px] border-gray-500 rounded-sm'>
            <table id='jy_table' className='w-full'>
              <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center border-b-[1px] border-gray-500 sticky top-0 z-10'>
                <tr className=''>
                  {columns_jy.map((column) => (
                    <th className='p-3' key={column}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody className='text-center'>
                {
                  books_jy.length ?
                  books_jy.map((book, idx) => (
                    <tr className=
                    {`
                      duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                      ${selectedRowJY === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                    `}
                    key={idx} onClick={(e)=>{
                      // 셀렉트 테스트
                      setSelectedRowJY(idx);
                      window.sessionStorage.setItem('select_copy', book.name);
                    }}>
                      <td className='p-2.5'>{idx + 1}</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.brand}</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.name}</td>
                      <td className='p-2.5'>{NumberConvert(book.TOTAL_JY)} 개</td>
                    </tr>
                  ))
                  :
                  <tr className='relative'>
                    <td className='absolute w-full md:top-[10vh] top-[3vh] left-auto'>
                      <NotData/>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <div className='overflow-y-auto md:h-full h-[30vh] border-[1px] border-gray-500 rounded-sm'>
            <table id='cd_table' className='w-full'>
              <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center border-b-[1px] border-gray-500 sticky top-0 z-10'>
                <tr className=''>
                  {columns_cd.map((column) => (
                    <th className='p-3' key={column}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody className='text-center'>
                {
                  books_cd.length ?
                  books_cd.map((book, idx) => (
                    <tr className=
                    {`
                      duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                      ${selectedRowCD === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                    `}
                    key={idx} onClick={(e)=>{
                      // 셀렉트 테스트
                      setSelectedRowCD(idx);
                      window.sessionStorage.setItem('select_copy', book.name);
                    }}>
                      <td className='p-2.5'>{idx + 1}</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.brand}</td>
                      <td className='p-2.5 border-x-[1px] border-gray-500'>{book.name}</td>
                      <td className='p-2.5'>{NumberConvert(book.TOTAL_CD)} 개</td>
                    </tr>
                  ))
                  :
                  <tr className='relative'>
                    <td className='absolute w-full md:top-[10vh] top-[3vh] left-auto'>
                      <NotData/>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

        </div>

        {/* 사이드 */}
        <div className='w-full md:w-1/4 bg-[#424242] border-[1px] border-gray-500'>
          <div className='bg-[#0067BD] py-2 text-center'>
            <p className='text-left pl-3'>
              ※ 판매량 데이터 조회
            </p>
          </div>

          <div className='p-3 flex flex-col gap-2'>

          {/* 날짜 조회 */}
          <div className='grid lg:grid-cols-2 grid-cols-1 gap-2'>
            <div className=''>
              <p>시작 날짜</p>
              <input type='date' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400' value={startDate} onChange={(e)=>setStartDate(e.target.value)}/>
            </div>    
            <div className=''>
              <p>종료 날짜</p>
              <input type='date' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400' value={endDate} onChange={(e)=>setEndDate(e.target.value)} />
            </div>              
          </div>   

          {/* 언더라인 */}
          <div className='border-b-[1px] border-gray-400 py-1'></div>

          {/* 제품검색 */}
          <div className='w-full grid gap-2'>
            <p>분류 조회</p>
            <select className='w-full h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' onChange={handleSelect} >
              {itemTypeList.map((item) => (
                <option value={item} key={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <form autoComplete='off'>
            {/* 제품 검색어 */}
            <div className='w-full grid gap-2'>
              <p>제품명 검색</p>
              <input ref={firstCursor} className='bg-[#2E2E2E] h-12 w-full p-2 rounded-md text-center outline-none border-[1px] border-gray-400' type='search' placeholder='브랜드 or 이름' value={searchText} onChange={(e)=>setSearchText(e.target.value)} onDoubleClick={()=>setSearchText(window.sessionStorage.getItem('select_copy'))}/>
            </div>

            {/* 판매 취소 */}
            <div className='flex flex-col gap-2 pt-2'>
              <button className='bg-[#2E2E2E] h-12 w-[100%] rounded-md text-center border-[1px] border-yellow-300' onClick={btnSearchClick} >
                판매량 조회
              </button>
            </div>
          </form>

          {/* <div className='grid grid-cols-3 justify-center items-center text-center'>
            <div className='border-b-[1px] border-gray-400'></div>
            <p className='text-center'>또는</p>
            <div className='border-b-[1px] border-gray-400'></div>
          </div> */}

          </div>
        </div>

      </div>

    </div>

  )
}

export default Chart_1